module.exports = __webpack_public_path__ + "img/welcome-owl.bfb99211.svg";